/** Customer-safe labels for AP-2/AP-4 archive autopublish blocker reason codes. */

const BLOCKER_LABELS: Record<string, string> = {
  autopublish_off: 'Archive auto-publish is off.',
  dry_run_only: 'Dry run shows what would happen without publishing.',
  controlled_apply_locked: 'Controlled publishing is locked until post-launch Stage 2.',
  side_confirmation_required: 'Broadcaster side confirmation is required.',
  needs_attention_required: 'Open Needs Attention items must be cleared first.',
  schedule_review_required: 'Schedule review is required before autopublish can proceed.',
  season_rollover_review_required: 'Season rollover review is required.',
  team_assignment_review_required: 'Team assignment review is required.',
  vod_missing: 'Twitch VOD is not available yet for this archive.',
  confidence_below_threshold: 'Live confidence is below the required threshold.',
  billing_required: 'Active League Stream Center subscription is required.',
  manual_hold_active: 'This archive is on manual hold.',
  global_kill_switch_active: 'Archive autopublish is temporarily paused.',
  global_autopublish_disabled: 'Archive autopublish is temporarily paused.',
  league_autopublish_disabled: 'Archive autopublish is paused for this league.',
  league_kill_switch: 'Archive autopublish is paused for this league.',
  candidate_hold: 'This archive is on manual hold.',
  duplicate_archive_risk: 'Duplicate archive risk requires review.',
  unknown_review_required: 'Review is required before autopublish can proceed.',
  eligible_for_dry_run: 'This archive would qualify for dry-run preview only.',
};

export function archiveAutopublishBlockerCustomerLabel(code: string): string {
  const key = (code || '').trim().toLowerCase();
  return BLOCKER_LABELS[key] || 'Review is required before autopublish can proceed.';
}

export function archiveAutopublishBlockerCustomerLabels(codes: string[] | undefined | null): string[] {
  const seen = new Set<string>();
  const labels: string[] = [];
  for (const code of codes || []) {
    const label = archiveAutopublishBlockerCustomerLabel(code);
    if (seen.has(label)) continue;
    seen.add(label);
    labels.push(label);
  }
  return labels;
}
